import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice d'âge";
const DESCRIPTION =
  "Calculez dates, durees et ages en ligne avec precision pour vos besoins personnels et administratifs.";
const KEYWORDS =
  "calculatrice age et date, duree, calendrier, calcul en ligne";
const OG_URL =
  "https://do-calculate.com/calculator/fr/age-calculator/";
function AgeCalculator() {
  const [birthDate, setBirthDate] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (!birthDate) {
        setError("Veuillez entrer une date de naissance");
        setResult(null);
        return;
      }
      const birth = new Date(birthDate);
      const today = new Date();
      if (birth > today) {
        setError("La date de naissance ne peut pas être dans le futur");
        setResult(null);
        return;
      }
      let age = today.getFullYear() - birth.getFullYear();
      const monthDiff = today.getMonth() - birth.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
      }
      const totalDays = Math.floor((today - birth) / (24 * 60 * 60 * 1000));
      const years = Math.floor(totalDays / 365.25);
      const remainingDays = totalDays % 365.25;
      const months = Math.floor(remainingDays / 30.44);
      const days = Math.floor(remainingDays % 30.44);
      setResult({
        years: years,
        months: months,
        days: days,
        totalDays: totalDays
      });
      setError("");
    } catch (err) {
      setError("Erreur lors du calcul");
      setResult(null);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice d'âge calcule votre âge exact en années, mois et jours
                  à partir de votre date de naissance. Elle affiche également le nombre
                  total de jours vécus.
                </p>
                <ul>
                  <li>Calcul précis de l'âge</li>
                  <li>Affiche années, mois et jours</li>
                  <li>Total de jours vécus</li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Date de naissance
                      </label>
                      <input
                        type="date"
                        value={birthDate}
                        onChange={(e) => setBirthDate(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p><strong>{result.years}</strong> ans, <strong>{result.months}</strong> mois, <strong>{result.days}</strong> jours</p>
                      <p>Total: <strong>{result.totalDays}</strong> jours</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Calculer son âge précisément</h3></div>
              <div className="info-section-body">
                <p>La calculatrice d'âge détermine votre âge exact en années, mois et jours à partir de votre date de naissance. Elle prend en compte les années bissextiles et calcule automatiquement votre prochain anniversaire. Vous obtenez aussi votre âge exprimé en semaines, jours totaux, heures, minutes et secondes pour satisfaire votre curiosité.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>L'âge légal en France</h3></div>
              <div className="info-section-body">
                <p>En France, plusieurs droits s'acquièrent à des âges précis : 16 ans pour le permis de conduire accompagné, 18 ans pour la majorité civile et pénale, 25 ans pour le RSA, 62 ans pour la retraite anticipée, et 64 ans pour l'âge légal de départ à la retraite depuis la réforme de 2023. Connaître son âge exact reste donc utile dans de nombreuses démarches.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Comment calculer l'âge ?</div>
              <div className="info-section-body">
                <p>Le calcul de l'âge suit ces étapes :</p>
                <ol>
                  <li><strong>Soustraire les jours :</strong> si le résultat est négatif, on emprunte au mois précédent.</li>
                  <li><strong>Soustraire les mois :</strong> si le résultat est négatif, on emprunte à l'année précédente.</li>
                  <li><strong>Soustraire les années :</strong> différence entre l'année actuelle et l'année de naissance.</li>
                </ol>
                <p>Une calculatrice électronique gère automatiquement les années bissextiles et les mois de longueurs différentes (28, 29, 30 ou 31 jours), évitant toute erreur manuelle.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Calendrier grégorien et calendrier hégirien</div>
              <div className="info-section-body">
                <p><strong>Calendrier grégorien</strong> (solaire) : basé sur la révolution de la Terre autour du Soleil — 365 ou 366 jours, utilisé dans le monde entier, les saisons sont fixes.</p>
                <p><strong>Calendrier hégirien</strong> (lunaire) : basé sur les phases de la Lune — 354 ou 355 jours, utilisé pour les occasions religieuses islamiques. Les saisons se décalent d'environ 11 jours par an.</p>
                <p>La différence entre les deux calendriers augmente d'environ 1 an tous les 33 années grégoriennes.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Calcul de l'âge en jours et en heures</div>
              <div className="info-section-body">
                <p>Votre âge peut être exprimé en différentes unités :</p>
                <ul>
                  <li><strong>Années, mois, jours</strong> — le format standard</li>
                  <li><strong>Heures</strong> — précis pour les événements médicaux ou les défis</li>
                  <li><strong>Minutes et secondes</strong> — satisfait la curiosité</li>
                </ul>
                <p>Le nombre de jours est indépendant du système calendaire utilisé, ce qui en fait l'unité la plus universelle pour comparer des âges.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Calcul de l'âge d'un enfant</div>
              <div className="info-section-body">
                <p>Pour les nourrissons et les jeunes enfants, connaître l'âge précis est essentiel pour :</p>
                <ul>
                  <li>Suivre le calendrier vaccinal (BCG, DTP, ROR...)</li>
                  <li>Évaluer les étapes de développement (marche, langage)</li>
                  <li>Déterminer les stades nutritionnels (diversification alimentaire)</li>
                  <li>L'inscription scolaire (âge requis en CP)</li>
                  <li>Les ajustements de dosage médicamenteux en pédiatrie</li>
                </ul>
                <p>Pour un nouveau-né, l'âge peut être calculé en heures et en jours pour un suivi médical précis.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Faits surprenants sur votre âge</div>
              <div className="info-section-body">
                <ul>
                  <li>Votre cœur bat environ <strong>100 000 fois par jour</strong> (70 battements/min en moyenne)</li>
                  <li>Vous respirez environ <strong>20 000 fois par jour</strong> (14 à 16 respirations/min)</li>
                  <li>Vous passez environ <strong>1/3 de votre vie à dormir</strong> (8 heures par nuit en moyenne)</li>
                  <li>Une personne de 40 ans a vécu environ <strong>14 610 jours</strong></li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Pourquoi utiliser une calculatrice d'âge électronique ?</div>
              <div className="info-section-body">
                <ul>
                  <li><strong>Rapidité :</strong> résultat instantané</li>
                  <li><strong>Précision :</strong> gestion automatique des années bissextiles</li>
                  <li><strong>Facilité :</strong> aucune aptitude en calcul mental requise</li>
                  <li><strong>Complétude :</strong> âge en années, mois, jours, heures, minutes et secondes</li>
                  <li><strong>Gratuite :</strong> accessible à tout moment depuis n'importe quel appareil</li>
                </ul>
                <p><strong>Usages concrets :</strong> vérifier l'âge pour un formulaire officiel, calculer une différence d'âge en famille, planifier la retraite, déterminer l'éligibilité à un service.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Questions fréquentes</div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "16px" }}><strong>La calculatrice tient-elle compte des années bissextiles ?</strong></h3>
                <p>Oui, la calculatrice prend automatiquement en compte les années bissextiles (29 février) pour garantir une précision totale, même sur de très longues périodes.</p>
                <hr />
                <h3 style={{ fontSize: "16px" }}><strong>Comment calculer l'âge d'un nouveau-né ?</strong></h3>
                <p>Pour les nourrissons, la calculatrice affiche l'âge en jours, heures et minutes depuis la naissance — utile pour le suivi médical et vaccinal des premières semaines de vie.</p>
                <hr />
                <h3 style={{ fontSize: "16px" }}><strong>Mes données sont-elles conservées ?</strong></h3>
                <p>Non, aucune donnée personnelle n'est stockée. Les calculs s'effectuent directement dans votre navigateur sans envoi vers un serveur.</p>
                <hr />
                <h3 style={{ fontSize: "16px" }}><strong>Puis-je connaître le jour de la semaine de ma naissance ?</strong></h3>
                <p>Oui, la calculatrice indique automatiquement le jour de la semaine correspondant à votre date de naissance.</p>
                <hr />
                <h3 style={{ fontSize: "16px" }}><strong>La calculatrice fonctionne-t-elle sur mobile ?</strong></h3>
                <p>Oui, l'outil est entièrement responsive et fonctionne sur smartphone, tablette et ordinateur.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AgeCalculator;
